import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import {
	type LWApiPublicMarketCartDetailsParamsRawI,
	type LWApiPublicMarketCartDetailsResultRawI,
} from '@liquidweb-dev/club-sauce/public/market/cart/index.raw';
import type { ApiErrorI } from '@liquidweb-dev/club-sauce/types/apiError';
import api from 'modules/queries/api';
import { MARKET_CART_DETAILS_QUERY_KEY } from '../useDetails';

const useCartItemDetails = (
	params: LWApiPublicMarketCartDetailsParamsRawI,
	options?: UseQueryOptions<LWApiPublicMarketCartDetailsResultRawI, ApiErrorI>,
) =>
	useQuery({
		queryKey: [MARKET_CART_DETAILS_QUERY_KEY, params],
		queryFn: () => api.market.cart.apiRaw.details(params),
		...options,
	});

export default useCartItemDetails;
